import './kvolunteer.css';

function Volunteer() {
  return (

        <section id="sbs-1431">
            <div className="cs-container">
                <div className="cs-image-group">
                   
                    <picture className="cs-person">
                        <source media="(max-width: 600px)" srcset="/images/volunteer.png"></source>
                        <source media="(min-width: 601px)" srcset="/images/volunteer.png"></source>
                        <img loading="lazy" decoding="async" src="/images/volunteer.png" alt="volunteer" width="702" height="617" aria-hidden="true"></img>
                    </picture>
                </div>
                <div className="cs-content">
                    <span className="cs-topper">Giving Back</span>
                    <h2 className="cs-title">Volunteer Opportunities</h2>
                    <p className="cs-text">
                        We relie on the generosity of individuals like you to continue our work. Your donations help us run the Temple, Every Day Bhog and Every Saunday special Kirtan Festival, and make a positive impact in our community.
                    </p>
                    <ul className="cs-card-group">
                        <li className="cs-li">
                            <picture className="cs-li-picture">
                                <img className="cs-li-icon" aria-hidden="true" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/volunteer1.svg" decoding="async" alt="icon" width="32" height="32" loading="lazy"></img>
                            </picture>
                            <div className="cs-flex">
                                <h3 className="cs-h3">Become a Volunteer</h3>
                                <p className="cs-li-text">
                                    Temple of Krishna is an organization that relies on the generosity of individuals like you to continue our work. Your donations help us provide essential services, support those in need, and make a positive impact in our community.
                                </p>
                            </div>
                        </li>
                        <li className="cs-li">
                            <picture className="cs-li-picture">
                                <img className="cs-li-icon" aria-hidden="true" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/volunteer2.svg" decoding="async" alt="icon" width="32" height="32" loading="lazy"></img>
                            </picture>
                            <div className="cs-flex">
                                <h3 className="cs-h3">Quick Fundraise</h3>
                                <p className="cs-li-text">
                                    <a href="/donate">Donate</a> to make a donation. You can choose to make a one-time donation or set up a recurring donation to support our ongoing efforts.
                                </p>
                            </div>
                        </li>
                        <li className="cs-li">
                            <picture className="cs-li-picture">
                                <img className="cs-li-icon" aria-hidden="true" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/volunteer3.svg" decoding="async" alt="icon" width="32" height="32" loading="lazy"></img>
                            </picture>
                            <div className="cs-flex">
                                <h3 className="cs-h3">Start Volunteering</h3>
                                <p className="cs-li-text">
                                    Help us spread the word about our cause. Share our mission with your friends, family, and social networks to raise awareness and encourage others to get involved.
                                </p>
                            </div>
                        </li>
                    </ul>             
                </div>
            </div>
        </section>
                                
  );
}   

export default Volunteer;